<!-- header -->
<sign-up-header></sign-up-header>

<!-- main content -->
<div class="main-content-container">
    <div class="container-spaced">
        
        <!-- 1st column: Features -->
        <!--<options [package]="package" [licenseType]="licenseType"></options>-->
        
        <!-- 2nd column: Setup Organization View -->
        <div class="main-container cnt-column-centered g4Border payment-width-container">
            
            <!-- Sign-up steps -->
            <!--<sign-up-steps [thirdForm]="true" [licenseType]="licenseType"></sign-up-steps>-->

            <!-- Main container -->
            <div class="create-account-bgrnd" data-testid="winRegister">
                <div [height]="20"></div>

                <!-- Main inside container -->
                <div class="cnt-column-centered">

                    <!-- Header of step -->
                    <div class="cnt-flex">
                        <div class="h1Font text-align-left o1Color" i18n>{{ 'CONFIRM_YOUR_PRICING_OPTION' | translate }}</div>
                    </div>

                    <div [height]="20"></div>
                    
                    <!-- First text container -->
                    <div class="text-align-left landing-font option-features-font-size b1Color" [style.font-size.px]="15" i18n>
                        {{ 'YOU_HAVE_SELECTED' | translate }} <span class="weight-tittle landing-font">{{package}}</span>. {{ 'PLEASE_CHOSE_ONE_OF' | translate }}:
                    </div>
                    
                    <div [height]="40"></div>

                    <!-- Payment container -->
                    <div class="cnt-column currency-container-offset">

                        <!-- Currencies container -->
                        <div>
                            <span *ngFor="let currencySymbol of currencySymbols">
                                <span class="font-size-text" (click)="selectCurrency(currencySymbol.value)" [ngClass]="{'font-size-text font-wight cursor-pointer o1Color landing-font text-align-left': currencySymbol!.disabled, 'font-size-text cursor-pointer b1Color landing-font text-align-left': !currencySymbol!.disabled}">{{currencySymbol.value}}</span>&nbsp;&nbsp;&nbsp;
                            </span>
                        </div>
                        
                        <!-- Choose subscription container -->
                        <div class="cnt-row-centered justify-content-around price-container">
                            <div class="cnt-column-centered">
                                <div [ngClass]="{'price-bold font-wight b1Color landing-font text-align-center': monthlyPlan, 'price b1Color landing-font text-align-center': !monthlyPlan}">{{currentCurrencySymbol}}{{currentPriceMonthly}}</div>
                                <div class="font-size-text b1Color landing-font text-align-center" i18n>{{ 'PER_MONTH' | translate }}</div>
                                <div class="cnt-row">
                                    <div (click)="selectPricePlan(0)" [ngClass]="{'radio-checked-orange': monthlyPlan, 'radio-empty-orange': !monthlyPlan}"></div>
                                    <div class="paid-selection o1Color landing-font text-align-center" i18n>{{ 'PAID_MONTHLY' | translate }}</div>
                                </div>
                            </div>
                            <div class="separating-line-br"></div>
                            <div class="cnt-column-centered">
                                <div [ngClass]="{'price-bold font-wight b1Color landing-font text-align-center': annuallyPlan, 'price b1Color landing-font text-align-center': !annuallyPlan}">{{currentCurrencySymbol}}{{currentPriceAnnually}}</div>
                                <div class="font-size-text b1Color landing-font text-align-center" i18n>{{ 'PER_MONTH' | translate }}</div>
                                <div class="cnt-row">
                                    <div (click)="selectPricePlan(1)" [ngClass]="{'radio-checked-orange': annuallyPlan, 'radio-empty-orange': !annuallyPlan}"></div>
                                    <div class="paid-selection o1Color landing-font text-align-center" i18n>{{ 'PAID_ANNUALLY' | translate }}</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                    <!-- Button container -->
                    <div class="cnt-row-centered btnBottom">
                        <div [ngClass]="{
                                'brixxLogo-small' : !isBusinessDoctors,
                                'businessDoctorsLogo-small' : isBusinessDoctors
                             }"
                             ></div>
                        <div [width]="20"></div>
                        <simple-btn class="btnBottomStyle"
                                    [horizontalPadding]="32"
                                    (click)="goToPayment()"
                                    [width]="210"
                                    [text]="buttonText"
                                    [backgroundFillCls]="'o2Background'"
                                    [hoverFillCls]="'o1Background'"
                                    [boxShadowCls]="'primary-shadow'"
                                    textCls="h5Font"
                                    data-testid="appTour"
                                    [textCls]="'large-btn-text'"
                                    [height]="40"
                                    [cornerRadius]="50">
                        </simple-btn>
                    </div>
                </div>
                <div [height]="14"></div>
            </div>
        </div>
    </div>
</div>
